import React, { Fragment } from 'react';
import { Dialog } from './../../common/dialog';
import 'react-tippy/dist/tippy.css';
import { empty } from './../../../utils';

const FormModal = React.memo((props) => {
    const hideHandler = () => {
        props.setIdModal(null);
        props.setFields({});
        props.setPermissions('[]');
        props.hideFormModal();
    };

    const handleFieldChange = (field, event) => {
        props.setField(field, event.target.value);
    };

    let buttonLabel = 'Save';
    if (props.saving) {
        buttonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    let newPasswordLabel = 'Password';
    if (!empty(props.fields.id)) {
        newPasswordLabel = <Fragment>New password (leave blank to leave unchanged){props.fields.id ? null : <span className="ml-1 required">*</span>}</Fragment>;
    }

    let confirmPasswordLabel = 'Confirm Password';
    if (!empty(props.fields.id)) {
        confirmPasswordLabel = <Fragment>Confirm new password (leave blank to leave unchanged){props.fields.id ? null : <span className="ml-1 required">*</span>}</Fragment>;
    }

    const handleClickPermission = (event) => {
        if (event.target.checked) {
            props.addPermission(event.target.value);
        } else {
            props.removePermission(event.target.value);
        }
    };

    const validatePermission = (value) => {
        return props.permissions.includes(value);
    };

    let actions = [
        <button key="save-button" className="btn btn-light btn-sm action-button" onClick={props.saveUser}>{buttonLabel}</button>,
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Close</button>
    ];
    return (
        <Dialog
            name="form-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 1000 }}
            bodyStyle={{ overflow: 'initial' }}
            className="admin-user-form-modal-dialog"
        >
            <div className="admin-user-form-modal-container">
                <div className="title">User</div>
                <div className="subtitle">Information</div>
                <div className="info-fields">
                    <div className="field">
                        <div className="label">Name <span className="required">*</span>:</div>
                        <input type="text" value={props.fields.name} onChange={handleFieldChange.bind(this, 'name')} placeholder="Name" />
                    </div>
                    <div className="field">
                        <div className="label">Email <span className="required">*</span>:</div>
                        <input type="text" value={props.fields.email} onChange={handleFieldChange.bind(this, 'email')} placeholder="Email" />
                    </div>
                    <div className="field">
                        <div className="label">{newPasswordLabel}:</div>
                        <input type="password" value={props.fields.new_password} onChange={handleFieldChange.bind(this, 'new_password')} placeholder="Password" />
                    </div>
                    <div className="field">
                        <div className="label">{confirmPasswordLabel}:</div>
                        <input type="password" value={props.fields.confirm_password} onChange={handleFieldChange.bind(this, 'confirm_password')} placeholder="Password" />
                    </div>
                </div>
                <div className="subtitle permissions-title">Permissions</div>
                <div className="permission-fields">
                    <h2>Orders</h2>
                    <div className="field">
                        <input type="checkbox" value="orders-view-all" onClick={handleClickPermission} checked={validatePermission('orders-view-all')} /> View All Orders
                    </div>
                    <div className="field">
                        <input type="checkbox" value="orders-utp-report" onClick={handleClickPermission} checked={validatePermission('orders-utp-report')} /> Export UTP Report
                    </div>
                    <div className="field">
                        <input type="checkbox" value="orders-acm-report" onClick={handleClickPermission} checked={validatePermission('orders-acm-report')} /> Export ACM Report
                    </div>
                    <div className="field">
                        <input type="checkbox" value="orders-reorder" onClick={handleClickPermission} checked={validatePermission('orders-reorder')} /> Re-order
                    </div>
                    <div className="field">
                        <input type="checkbox" value="orders-info" onClick={handleClickPermission} checked={validatePermission('orders-info')} /> View Information
                    </div>
                    <div className="field">
                        <input type="checkbox" value="orders-pdf" onClick={handleClickPermission} checked={validatePermission('orders-pdf')} /> View PDF
                    </div>
                    <div className="field">
                        <input type="checkbox" value="orders-action" onClick={handleClickPermission} checked={validatePermission('orders-action')} /> Approve/Reject Order
                    </div>
                    <div className="field">
                        <input type="checkbox" value="orders-sc-ticket" onClick={handleClickPermission} checked={validatePermission('orders-sc-ticket')} /> Create SC Ticket
                    </div>
                    <div className="field">
                        <input type="checkbox" value="orders-packing-slip" onClick={handleClickPermission} checked={validatePermission('orders-packing-slip')} /> View Packing Slip
                    </div>
                    <div className="field">
                        <input type="checkbox" value="orders-shipping" onClick={handleClickPermission} checked={validatePermission('orders-shipping')} /> View Shipping Information
                    </div>
                    <h2>Help Desk</h2>
                    <div className="field">
                        <input type="checkbox" value="help-desk" onClick={handleClickPermission} checked={validatePermission('help-desk')} /> View Help Desk Module
                    </div>
                    <div className="field">
                        <input type="checkbox" value="help-desk-response" onClick={handleClickPermission} checked={validatePermission('help-desk-response')} /> Send Response
                    </div>
                    <div className="field">
                        <input type="checkbox" value="help-desk-email-print" onClick={handleClickPermission} checked={validatePermission('help-desk-email-print')} /> Send Print Notification
                    </div>
                    <div className="field">
                        <input type="checkbox" value="help-desk-email-apparel" onClick={handleClickPermission} checked={validatePermission('help-desk-email-apparel')} /> Send Apparel Notification
                    </div>
                    <div className="field">
                        <input type="checkbox" value="help-desk-email-promo" onClick={handleClickPermission} checked={validatePermission('help-desk-email-promo')} /> Send Promotional Notification
                    </div>
                    <div className="field">
                        <input type="checkbox" value="help-desk-email-fitting" onClick={handleClickPermission} checked={validatePermission('help-desk-email-fitting')} /> Send Fitting Notification
                    </div>
                    <div className="field">
                        <input type="checkbox" value="help-desk-email-other" onClick={handleClickPermission} checked={validatePermission('help-desk-email-other')} /> Send Other Notification
                    </div>
                    <h2>Departments Module</h2>
                    <div className="field">
                        <input type="checkbox" value="departments" onClick={handleClickPermission} checked={validatePermission('departments')} /> View Departments Module
                    </div>
                    <div className="field">
                        <input type="checkbox" value="departments-create" onClick={handleClickPermission} checked={validatePermission('departments-create')} /> Create Department
                    </div>
                    <div className="field">
                        <input type="checkbox" value="departments-edit" onClick={handleClickPermission} checked={validatePermission('departments-edit')} /> Edit Department
                    </div>
                    <div className="field">
                        <input type="checkbox" value="departments-delete" onClick={handleClickPermission} checked={validatePermission('departments-delete')} /> Delete Department
                    </div>
                    <h2>Apparel Module</h2>
                    <div className="field">
                        <input type="checkbox" value="apparel" onClick={handleClickPermission} checked={validatePermission('apparel')} /> View Apparel Module
                    </div>
                    <div className="field">
                        <input type="checkbox" value="apparel-create" onClick={handleClickPermission} checked={validatePermission('apparel-create')} /> Create Apparel
                    </div>
                    <div className="field">
                        <input type="checkbox" value="apparel-edit" onClick={handleClickPermission} checked={validatePermission('apparel-edit')} /> Edit Apparel
                    </div>
                    <div className="field">
                        <input type="checkbox" value="apparel-delete" onClick={handleClickPermission} checked={validatePermission('apparel-delete')} /> Delete Apparel
                    </div>
                    <div className="field">
                        <input type="checkbox" value="apparel-export" onClick={handleClickPermission} checked={validatePermission('apparel-export')} /> Export Apparel Excel
                    </div>
                    <div className="field">
                        <input type="checkbox" value="apparel-import" onClick={handleClickPermission} checked={validatePermission('apparel-import')} /> Import Apparel Excel
                    </div>
                    <div className="field">
                        <input type="checkbox" value="apparel-parts" onClick={handleClickPermission} checked={validatePermission('apparel-parts')} /> View Apparel Parts
                    </div>
                    <div className="field">
                        <input type="checkbox" value="apparel-parts-create" onClick={handleClickPermission} checked={validatePermission('apparel-parts-create')} /> Create Parts
                    </div>
                    <div className="field">
                        <input type="checkbox" value="apparel-parts-edit" onClick={handleClickPermission} checked={validatePermission('apparel-parts-edit')} /> Edit Parts
                    </div>
                    <div className="field">
                        <input type="checkbox" value="apparel-parts-delete" onClick={handleClickPermission} checked={validatePermission('apparel-parts-delete')} /> Delete Parts
                    </div>
                    <h2>Forms Module</h2>
                    <div className="field">
                        <input type="checkbox" value="forms" onClick={handleClickPermission} checked={validatePermission('forms')} /> View Forms Module
                    </div>
                    <div className="field">
                        <input type="checkbox" value="forms-create" onClick={handleClickPermission} checked={validatePermission('forms-create')} /> Create Form
                    </div>
                    <div className="field">
                        <input type="checkbox" value="forms-edit" onClick={handleClickPermission} checked={validatePermission('forms-edit')} /> Edit Form
                    </div>
                    <div className="field">
                        <input type="checkbox" value="forms-delete" onClick={handleClickPermission} checked={validatePermission('forms-delete')} /> Delete Form
                    </div>
                    <div className="field">
                        <input type="checkbox" value="forms-export" onClick={handleClickPermission} checked={validatePermission('forms-export')} /> Export Forms Excel
                    </div>
                    <div className="field">
                        <input type="checkbox" value="forms-import" onClick={handleClickPermission} checked={validatePermission('forms-import')} /> Import Forms Excel
                    </div>
                    <h2>Promotional Module</h2>
                    <div className="field">
                        <input type="checkbox" value="promotional" onClick={handleClickPermission} checked={validatePermission('promotional')} /> View Promotional Module
                    </div>
                    <div className="field">
                        <input type="checkbox" value="promotional-create" onClick={handleClickPermission} checked={validatePermission('promotional-create')} /> Create Promotional Item
                    </div>
                    <div className="field">
                        <input type="checkbox" value="promotional-edit" onClick={handleClickPermission} checked={validatePermission('promotional-edit')} /> Edit Promotional Item
                    </div>
                    <div className="field">
                        <input type="checkbox" value="promotional-delete" onClick={handleClickPermission} checked={validatePermission('promotional-delete')} /> Delete Promotional Item
                    </div>
                    <h2>Size Charts Module</h2>
                    <div className="field">
                        <input type="checkbox" value="size-charts" onClick={handleClickPermission} checked={validatePermission('size-charts')} /> View Size Charts Module
                    </div>
                    <div className="field">
                        <input type="checkbox" value="size-charts-create" onClick={handleClickPermission} checked={validatePermission('size-charts-create')} /> Create Size Chart
                    </div>
                    <div className="field">
                        <input type="checkbox" value="size-charts-edit" onClick={handleClickPermission} checked={validatePermission('size-charts-edit')} /> Edit Size Chart
                    </div>
                    <div className="field">
                        <input type="checkbox" value="size-charts-duplicate" onClick={handleClickPermission} checked={validatePermission('size-charts-duplicate')} /> Duplicate Size Chart
                    </div>
                    <div className="field">
                        <input type="checkbox" value="size-charts-delete" onClick={handleClickPermission} checked={validatePermission('size-charts-delete')} /> Delete Size Chart
                    </div>
                    <h2>Users Module</h2>
                    <div className="field">
                        <input type="checkbox" value="users" onClick={handleClickPermission} checked={validatePermission('users')} /> View Users Module
                    </div>
                    <div className="field">
                        <input type="checkbox" value="users-create" onClick={handleClickPermission} checked={validatePermission('users-create')} /> Create User
                    </div>
                    <div className="field">
                        <input type="checkbox" value="users-edit" onClick={handleClickPermission} checked={validatePermission('users-edit')} /> Edit User
                    </div>
                    <div className="field">
                        <input type="checkbox" value="users-delete" onClick={handleClickPermission} checked={validatePermission('users-delete')} /> Delete User
                    </div>
                    <h2>Reports Module</h2>
                    <div className="field">
                        <input type="checkbox" value="reports" onClick={handleClickPermission} checked={validatePermission('reports')} /> View Reports Module
                    </div>
                </div>
            </div>
        </Dialog >
    );
});

export default FormModal;
